import React from 'react';
import { AddressTypes, SectionHeader } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { CheckoutLayoutBlock } from '../../CheckoutLayout';
import { CheckoutBlockVStack } from '../CheckoutBlockVStack';
import { CustomerOptions } from './CheckoutDetailsBlock.customer';
import { DeliveryOptions } from './CheckoutDetailsBlock.delivery';
import { OutpostOptions } from './CheckoutDetailsBlock.outpost';
import { PickupOptions } from './CheckoutDetailsBlock.pickup';
import type { CheckoutDetailsBlockProps } from './CheckoutDetailsBlock.types';

export const CheckoutDetailsBlock = React.memo(
  (props: CheckoutDetailsBlockProps) => {
    const { orderType, customer } = props;
    const { t } = useLocalizationContext();
    const heading = t('checkout.block-details-title', { orderType });

    return (
      <CheckoutLayoutBlock {...props}>
        <SectionHeader heading={heading} />
        <CheckoutBlockVStack>
          {orderType === AddressTypes.pickup ? (
            <PickupOptions {...props} />
          ) : null}

          {orderType === AddressTypes.outpost ? (
            <OutpostOptions {...props} />
          ) : null}

          {orderType === AddressTypes.delivery ? (
            <DeliveryOptions {...props} />
          ) : null}

          {customer ? <CustomerOptions {...props} /> : null}
        </CheckoutBlockVStack>
      </CheckoutLayoutBlock>
    );
  },
);
